import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { SnackbarProvider } from "notistack";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import APIProvider from "./context";

const theme = createTheme({
  palette: {
    // type: 'dark',
    primary: {
      light: "#878fa7",
      main: "#3c496f",
      dark: "#030328",
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#e0f6f2",
      main: "#40ccb0",
      dark: "#00a380",
      contrastText: "#000000",
    },
    text: {
      primary: "#030328",
      secondary: "#00a380",
    },
  },
  overrides: {
    /* MuiCssBaseline: {
      '@global': {
        '@font-face': [agenda],
      },
    }, */
    MuiInputBase: {
      root: {
        color: "#1f3d4b",
      },
    },
    MuiTab: {
      root: {
        "&.MuiTab-root": {
          opacity: 1,
          border: 0,
          "&:hover": {
            border: 0,
          },
        },
        "&.Mui-selected": {
          border: 0,
        },
        /* "&.MuiTab-root": {
          backgroundColor: '#1f3d4b',
          color: '#0db2a7',
          opacity: 1,
          border: 0,
          "&:hover": {
            border: 0,
          },
        },
        "&.Mui-selected": {
          backgroundColor:'#0db2a7',
          color: '#1f3d4b',
          border: 0,
        } */
      },
    },
    MuiDropzoneArea: {
      root: {
        minHeight: "200px",
        display: "flex",
        justifyContent: "center",
      },
      textContainer: {
        maxWidth: "300px",
      },
    },

    MuiDropzonePreviewList: {
      image: {
        maxHeight: "200px",
      },
    },
  },

  typography: {
    //fontFamily: "Agenda, Arial",
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <APIProvider>
          <App />
        </APIProvider>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
